module.exports = __webpack_public_path__ + "img/lezhi04.7a02dc85.png";